import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { path } from "../../../order_managment/constants/apiPath";
import "./rms.css";
import axios from "axios";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import { CircularProgress } from "@material-ui/core";
import { baseUrlRate, LOCAL_STORAGE_KEY } from "../../../config";
import { getUserData } from "../../common/utility/Utils";
import { Autocomplete, Input, TextField } from "@mui/material";
import { width } from "@mui/system";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const CommonTable = ({ demo }) => {
  const [costData, setCostData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [OriginOptions, setOriginOptions] = useState([]);
  const [origin, setOrigin] = useState("");
  const [edit, setEdit] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [rowData, setRowData] = useState({
    maxRate: "",
    rateEffectiveTill: "",
    unitRate: "",
    minRate: "",
  });

  console.log("Cost Data: ", costData);
  const editRowData = (index) => {
    const foundData = costData.find((indvCost) => indvCost.id === index + 1);
    const tempData = { ...foundData, ...rowData };
    console.log("Temp Data: ", tempData);
    const finalData = [...costData];
    finalData[index] = tempData;
    console.log("Final Data: ", finalData);
    setCostData(finalData);
    setEdit(false);
  };

  const rowEdit = (item, index) => {
    const temp = {
      ...rowData,
      maxRate: item?.maxRate === 2147483647 ? "N/A" : item.maxRate,
      rateEffectiveTill:
        item?.rateEffectiveTill === "12/31/2099"
          ? "Today"
          : item.rateEffectiveTill,
      unitRate: item?.unitRate,
      minRate: item?.minRate === 0 ? "N/A" : item.minRate,
    };
    setRowData(temp);
    setEdit(true);
  };

  const getFreightOrigin = async () => {
    let data = {};
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });
    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };
    let url;
    if (demo === "FREIGHT") {
      url = `${baseUrlRate}${path.GET_FREIGHT_ORIGIN}`;
    } else {
      url = url = `${baseUrlRate}${path.GET_IPI_ORIGIN}`;
    }
    axios
      .get(url, {
        headers: header,
      })
      .then((res) => {
        setOriginOptions(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getRateByOrigin = async (origin) => {
    setLoading(true);
    let data = {};
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });
    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };
    let url;
    if (demo === "FREIGHT") {
      url = `${baseUrlRate}${path.COST_FREIGHT}?OriginCode=${origin}`;
    } else {
      url = `${baseUrlRate}${path.COST_IPI}?OriginCode=${origin}`;
    }

    axios
      .get(url, {
        headers: header,
      })
      .then((res) => {
        setLoading(false);
        setCostData(res?.data?.rateFromGivenOrigin ?? []);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getFreightOrigin();
  }, []);

  return (
    <>
      <Autocomplete
        sx={{ width: 300, marginBottom: "1rem" }}
        disablePortal
        id="combo-box-demo"
        options={OriginOptions}
        renderInput={(params) => <TextField {...params} label="Origin" />}
        onChange={(event, newValue) => {
          setOrigin(newValue?.originCode ?? "");
          getRateByOrigin(newValue?.originCode ?? "");
        }}
        getOptionLabel={(option) => option.origin}
      />
      {origin !== "" ? (
        <>
          {loading ? (
            <div
              style={{
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 550 }} aria-label="simple table">
                <TableHead>
                  <TableRow className="table-row">
                    <TableCell className="table-row"> #</TableCell>
                    <TableCell className="table-row">Origin</TableCell>
                    <TableCell className="table-row">Destination</TableCell>
                    <TableCell className="table-row">Unit Rate</TableCell>
                    <TableCell className="table-row">Min Rate</TableCell>
                    <TableCell className="table-row">Max Rate</TableCell>
                    <TableCell className="table-row">
                      Rate Effective Till
                    </TableCell>
                    <TableCell className="table-row d-flex justify-content-center">
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {!costData.length ? (
                    <TableRow>
                      <TableCell className="row-data" colSpan={7}>
                        No Data Found!
                      </TableCell>
                    </TableRow>
                  ) : (
                    costData.map((item, index) => (
                      <TableRow
                        key={item.id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {item?.id}
                        </TableCell>
                        <TableCell>{item?.origin}</TableCell>
                        <TableCell>{item?.destination}</TableCell>
                        <TableCell>
                          {edit && editIndex === index ? (
                            <>
                              <input
                                defaultValue={item?.unitRate}
                                type="text"
                                style={{ width: "70px", height: "30px" }}
                                onChange={(e) => {
                                  console.log(e.target.value);
                                  setRowData({
                                    ...rowData,
                                    unitRate: e.target.value,
                                  });
                                }}
                              />
                            </>
                          ) : (
                            item?.unitRate
                          )}
                        </TableCell>
                        <TableCell>
                          {edit && editIndex === index ? (
                            <>
                              <input
                                required
                                defaultValue={
                                  item?.minRate === 0 ? "N/A" : item.minRate
                                }
                                type="text"
                                style={{ width: "70px", height: "30px" }}
                                onChange={(e) => {
                                  console.log(e.target.value);
                                  setRowData({
                                    ...rowData,
                                    minRate: e.target.value,
                                  });
                                }}
                              />
                            </>
                          ) : item?.minRate === 0 ? (
                            "N/A"
                          ) : (
                            item.minRate
                          )}
                        </TableCell>
                        <TableCell>
                          {edit && editIndex === index ? (
                            <>
                              <input
                                required
                                defaultValue={
                                  item?.maxRate === 2147483647
                                    ? "N/A"
                                    : item.maxRate
                                }
                                type="text"
                                style={{ width: "70px", height: "30px" }}
                                onChange={(e) => {
                                  console.log(e.target.value);
                                  setRowData({
                                    ...rowData,
                                    maxRate: e.target.value,
                                  });
                                }}
                              />
                            </>
                          ) : item?.maxRate === 2147483647 ? (
                            "N/A"
                          ) : (
                            item.maxRate
                          )}
                        </TableCell>
                        <TableCell>
                          {edit && editIndex === index ? (
                            <>
                              <input
                                required
                                defaultValue={
                                  item?.rateEffectiveTill === "12/31/2099"
                                    ? "Today"
                                    : item.rateEffectiveTill
                                }
                                type="text"
                                style={{ width: "150px", height: "30px" }}
                                onChange={(e) => {
                                  console.log(e.target.value);
                                  setRowData({
                                    ...rowData,
                                    rateEffectiveTill: e.target.value,
                                  });
                                }}
                              />
                            </>
                          ) : item?.rateEffectiveTill === "12/31/2099" ? (
                            "Today"
                          ) : (
                            item.rateEffectiveTill
                          )}{" "}
                        </TableCell>
                        <TableCell>
                          <div className="d-flex justify-content-between px-2">
                            <EditIcon
                              onClick={() => {
                                setEditIndex(index);
                                rowEdit(item, index);
                              }}
                            />
                            {edit && editIndex === index ? (
                              <CheckCircleIcon
                                color="success"
                                onClick={() => editRowData(index)}
                              />
                            ) : (
                              ""
                            )}
                          </div>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </>
      ) : null}
    </>
  );
};

export default React.memo(CommonTable);
